<template>
  <v-container class="fill-height bg-neutral" fluid>

            <v-img v-if="!logo" :src="`@/assets/img/KNAPP_Logo_White_300.png`" contain max-width="120" class="app-logo" alt="KNAPP"></v-img>
            <v-img v-else :src="logo" contain max-width="120" class="app-logo" alt="KNAPP"></v-img>
    <v-row align="center" justify="center">
      <v-col cols="auto">

        <h3 v-if="isDev" class="environment-title">DEV ENVIRONMENT</h3>
        <h3 v-else-if="isStage" class="environment-title">STAGE ENVIRONMENT</h3>
        <v-card class="pa-2 elevation-0" :disabled="formDisabled" dark color="transparent" style="min-width: 520px; max-width: 520px;">
          <v-toolbar color="rgb(255, 255, 255, .0)" elevation="0" >
            <h1 style="flex: 1; font-weight: 400; font-size: 28px; color: #EEE; text-transform: uppercase; text-align: center;">{{ title }}</h1>
          </v-toolbar>

          <v-card-text class="pb-0">
            <div class="errorContainer2 mb-4 pa-2 red--text" v-if="errorMsg2 != ''">
                <div class="font-weight-medium"><span v-html="errorMsg2" /></div>
            </div>
            <transition name="fade">
              <div class="errorContainer mb-4 pa-2 red--text" v-if="errorMsg != ''">
                <div class="font-weight-medium">{{ errorMsg }}</div>
                <template v-if="timeLeft > 0"
                  >Bitte warten Sie <strong>{{ timeLeft }}</strong> Sekunden</template
                >
              </div>
            </transition>
            <!-- Default LOGIN Screen -->
            <div v-show="isScreen == 'login'">
              <v-form @submit.prevent="submitLogin()" @keyup.native.enter="submitLogin()" ref="formLogin" v-model="formLoginValid" lazy-validation>
                <v-text-field
                  required
                  :rules="[rules.required]"
                  class="loginField"
                  label="Username"
                  name="login"
                  v-model="credentials.email"
                  prepend-icon="mdi-account-circle-outline"
                  type="text"
                ></v-text-field>
                <v-text-field
                  required
                  :rules="[rules.required]"
                  :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  label="Password"
                  class="loginField"
                  name="password"
                  @click:append="showPassword = !showPassword"
                  v-model="credentials.password"
                  prepend-icon="mdi-lock-outline"
                ></v-text-field>
              </v-form>
            </div>

            <!-- Request Reset Password -->
            <div v-show="isScreen == 'passwordForgotten'">
              <v-form @submit.prevent="submitRequestPasswordReset()" ref="formReset" v-model="formResetValid" lazy-validation>
                <v-text-field
                  :rules="[rules.required, rules.email]"
                  label="E-Mail"
                  v-model="requestPasswordEmail"
                  prepend-icon="mdi-email-outline"
                  type="text"
                ></v-text-field>
              </v-form>
            </div>

            <div v-show="isScreen == 'passwordForgottenMailSent'">
              <div class="mb-5 font-weight-medium">
                If a matching account was found an email was sent to <i>{{ requestPasswordEmail }}</i> to allow you to reset your password.
              </div>

            </div>

            <div v-show="isScreen == 'resetPassword'">
              <template v-if="!passwordResetSuccessMsg">
                <v-form @submit.prevent="submitPasswordReset()" ref="formReset2" v-model="formReset2Valid" lazy-validation>
                  <password-field v-model="passwordNew1" label="USER-LABEL-PASSWORD-NEW"></password-field>
                  <v-text-field
                    v-model="passwordNew2"
                    type="password"
                    :label="$t('USER-LABEL-PASSWORD_NEW-REPEAT')"
                    required
                    :rules="[passwordConfirmationRule]"
                  ></v-text-field>
                </v-form>
              </template>

              <template v-else>
                <div class="mb-5 font-weight-medium" v-html="passwordResetSuccessMsg"></div>
              </template>
            </div>
          </v-card-text>

          <v-card-actions class="justify-center flex-column">
            <template v-if="isScreen == 'login' && isForgotPasswordEnabled">
              <v-btn text @click="isScreen = 'passwordForgotten'">Forgot Password?</v-btn>
            </template>
            <template v-if="isScreen == 'login'">
              <v-btn dark class="white--text" style="padding: .25em 5em; margin-top: 1.5em;"  @click="submitLogin()" :loading="isLoading" color="primary" depressed :disabled="!formLoginValid"
                ><v-icon>mdi-check</v-icon></v-btn
              >
            </template>

            <template v-else-if="isScreen == 'passwordForgotten'">
              <v-btn text @click="isScreen = 'login'">Cancel</v-btn>
              <v-btn
                dark
                class="white--text"
                @click="submitRequestPasswordReset()"
                :loading="isLoading"
                color="primary"
                depressed
                :disabled="!formResetValid"
                >Reset Password</v-btn
              >
            </template>

            <template v-else-if="isScreen == 'passwordForgottenMailSent'"> </template>

            <template v-else-if="(isScreen = 'resetPassword')">
              <template v-if="!passwordResetSuccessMsg">
                <v-btn
                  dark
                  class="white--text"
                  @click="submitPasswordReset()"
                  :loading="isLoading"
                  color="primary"
                  depressed
                  :disabled="!formReset2Valid"
                  >Reset Password</v-btn
                >
              </template>
            </template>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <setup-wizard v-if="enableSetup" />
  </v-container>
</template>

<script>
import passwordField from "@/components/PasswordField";
import SetupWizard from "../components/setup/SetupWizard.vue";

export default {
  name: "Login",
  components: {
    passwordField,
    SetupWizard,
  },

  data() {
    return {
      isLoading: false,
      showPassword: false,

      formLoginValid: false,
      formResetValid: false,
      formReset2Valid: false,
      errorMsg: "",
      errorMsg2: "",
      isForgotPasswordEnabled: false,
      loginDelay: 0,
      timeLeft: 0,
      mandates: [],
      formDisabled: false,
      credentials: {
        email: "",
        password: "",
      },

      requestPasswordEmail: null,
      isScreen: "login",

      resetToken: null,
      passwordNew1: null,
      passwordNew2: null,

      passwordResetSuccessMsg: false,
    };
  },

   async created() {
    this.getMandates();
    await this.initForgotPasswordFeature();
    if (this.$route.name == "resetPassword") {
      this.isScreen = "resetPassword";

      if (!this.$route.params.token) {
        this.errorMsg = "No valid token found ...";
      } else {
        this.resetToken = this.$route.params.token;
      }

      this.formReset2Valid = false;
    }
  },

  watch: {
    isScreen(val) {
      if (val == "resetPassword") {
        this.formReset2Valid = false;
        return;
      }

      this.requestPasswordEmail = null;
      this.errorMsg = "";

      this.$refs.formLogin.resetValidation();
      this.$refs.formReset.resetValidation();

      setTimeout(() => {
        this.formLoginValid = false;
        this.formResetValid = false;
      });
    },
    isSessionExpired:{
      handler(val){
        if(!val) return;
        this.$store.dispatch("setSnackbar", {
              text: this.$t("GLOBAL_MESSAGE_SESSION_EXPIRED"),
              type: "error",
            });
            this.$store.commit("SET_SESSION_EXPIRED", false);
      },
      immediate: true
    }
  },

  computed: {
    logo(){
      if(!this.mandates.length) return '';
      const logo =  this.mandates[0].logo;
      if(!logo) return '';
      return  this.$config.uploads + logo;
      
    },

    isSessionExpired(){
        return this.$store.getters.isSessionExpired;
    },
       
    enableSetup() {
      return false;
    },

    isDev(){
      return this.$store.getters.envs.isDev;
    },

    isStage(){
      return this.$store.getters.envs.isStage;
    },

    passwordConfirmationRule() {
      return this.passwordNew1 === this.passwordNew2 || this.$t("GLOBAL-FORM-PASSWORDS_MUST_MATCH");
    },
    title() {
      switch (this.isScreen) {
        case "login":
          return "Genomix Login";

        case "passwordForgotten":
          return "Request New Password";

        case "passwordForgottenMailSent":
          return "E-Mail sent";

        case "resetPassword":
          return "Reset Password";
          default: 
          return '';
      }
    },
  },

  methods: {
    submitPasswordReset() {
      this.isLoading = true;
      this.errorMsg = "";
      this.errorMsg2 = "";

      this.axios.post("user/resetPassword", { reset_token: this.resetToken, new_password: this.passwordNew1 }).finally((res) => {
        this.passwordResetSuccessMsg =
          "<span class='green--text' style='font-size:18px;'>Your password was successfully changed.</span><br>You will be redirected to login in a few seconds ...";
        this.isLoading = false;

        setTimeout(() => {
          this.$router.push({ name: "login" });
          this.isScreen = "login";
        }, 4000);
      });
    },

    submitRequestPasswordReset() {
      this.isLoading = true;
      this.errorMsg = "";
      this.errorMsg2 = "";

      this.axios.post("user/requestPasswordReset", { email: this.requestPasswordEmail }).finally((res) => {
        this.isLoading = false;
        this.isScreen = "passwordForgottenMailSent";
      });
    },


    async initForgotPasswordFeature(){
      const output = await this.axios.get('config');
      this.isForgotPasswordEnabled = output.data.recoverPasswordEnabled;
    },

    getMandates(){
      this.axios.get("mandates").then((res) => {
        this.mandates = [...res.data]
      });
    },
    
    submitLogin() {
      this.isLoading = true;
      this.errorMsg = "";
      this.errorMsg2 = "";
      this.axios
        .post("login", this.credentials)
        .then((response) => {
          if (response.status == 200) {
            let user = response.data.user;
            let access_token = response.data.token;

            this.$store
              .dispatch("init", {
                user: user,
                token: access_token,
                i18n: this.$i18n,
                vuetify: this.$vuetify,
              })
              .then((res) => {
                this.isLoading = false;
                this.$router.push({
                  name: "dashboard",
                });

                this.$store.commit("SET_PAGE_LOADING", true);

                setTimeout(() => {
                  this.$store.commit("SET_PAGE_LOADING", false);
                }, 1200);
              });
          }
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.response.status == 401) {
            this.loginDelay = error.failedLoginDelay || 5;
            this.errorMsg = "Username oder Passwort stimmen nicht!";
            if(this.isDev || this.isStage){
              this.errorMsg2 = "If you have forgotten your password or it has expired, please contact <a href=\"mailto:MG_KSI_Genomix@knapp.com\" class=\"red--text\">MG_KSI_Genomix@knapp.com</a>.";
            }
            this.formDisabled = true;

            this.timeLeft = this.loginDelay;
            var downloadTimer = setInterval(() => {
              this.timeLeft--;

              if (this.timeLeft <= 0) {
                clearInterval(downloadTimer);
                this.errorMsg = "";
              }
            }, 1000);

            setTimeout(() => (this.formDisabled = false), this.loginDelay * 1000);
          }
        });
    },
  },
  mounted(){
    this.$store
              .dispatch("initBeforeAuthentication", {
                i18n: this.$i18n,
                vuetify: this.$vuetify,
              })
  }
};
</script>

<style lang="scss">
.bg {
  background-color: #404045;
}

.bg-neutral {
  background-color: #404045;
}
.errorContainer2 {
  border-radius: 2px;
  background-color: #fff;
}

.errorContainer {
  border-radius: 2px;
  background-color: #fff;
  /*background: rgba(255,255,255,0.95);*/
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.v-text-field .v-label--active {
  transform: translateY(-22px) scale(0.75);
}

.environment-title{
  color: #fff;
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 12px;
  padding: .25em .5em;
}
.loginField{
  & .v-icon.v-icon{
    font-size: 32px!important;
    margin-right: .5em;
    color: rgba(255,255,255,.8);
    margin-bottom: -10px;
  }
  
}

.app-logo{
  position: absolute;
  width: 150px;
  height: 100px;
  background: #fff;
  top: 0em;
  left: 3em;
}
</style>
